<template>
  <div id="app">
    
    <div class="background-top">
      <div class="content">
        <landing></landing>
      </div>
    </div>
    <sponsors type="platinum"></sponsors>
    <!-- <schedule></schedule> -->
    <gallery></gallery>
    <sponsors type="gold"></sponsors>
    <!-- <maps></maps> -->
    <sponsors type="silver"></sponsors>
  </div>
</template>

<script>

  import Landing from './components/Landing';
  import Gallery from './components/Gallery';
  import Maps from './components/Maps';
  import Schedule from './components/Schedule';
  import Sponsors from './components/Sponsors';

  export default {
    name: 'app',
    components: {Landing, Gallery, Maps, Schedule, Sponsors},
    data () {
      return {

      }
    }
  }

</script>

<style lang="scss">

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    position: fixed;

    top: 0;
    left: 0;
    right :0;
    bottom: 0;
    overflow-y: auto;

    .card {
      position: relative;
      margin: 0 auto 100px;
      box-shadow: 0px -4px 68px -5px rgba(0,0,0,0.37);

      &.no-margin {
        margin: 0;
      }
    }

    .content {
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      // max-width: 1100px;
      // width: calc(100% - 32px);
      // margin: 0 auto;
    }     

    .background-top,
    .background-bottom {
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
      padding: 0 0 0;
    }

    .background-top {
      background-image: url('./assets/back.jpg');
    }

    .background-bottom {
      padding: 100px 0 100px;
      background-image: url('./assets/fireworks-back-blur.jpg');
    }

  }

</style>
